const styles = {
  "progress-indeterminate": "_progress-indeterminate_1gb5n_1",
  "line-1": "_line-1_1gb5n_1",
  "line-1-indeterminate-animation": "_line-1-indeterminate-animation_1gb5n_1",
  "line-2": "_line-2_1gb5n_12",
  "line-2-indeterminate-animation": "_line-2-indeterminate-animation_1gb5n_1",
  "progress-determinate": "_progress-determinate_1gb5n_23",
  "linear-progressbar": "_linear-progressbar_1gb5n_35",
  "progress-bar": "_progress-bar_1gb5n_35"
};
export {
  styles as default
};
//# sourceMappingURL=LinearProgress.module.scss.js.map
